import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { makeObservable } from "mobx";
import { AbstractPostCollection, ClientCollection, RouteHttpVerb } from "@devowl-wp/utils";
import { TcfVendorConfigurationModel } from "./tcfVendorConfigurationModel.js";
import { request } from "../utils/request.js";
class TcfVendorConfigurationCollection extends AbstractPostCollection {
    store;
    constructor(store){
        super();
        makeObservable(this);
        this.store = store;
    }
    instance(response) {
        return new TcfVendorConfigurationModel(this).fromResponse(response);
    }
}
TcfVendorConfigurationCollection = _ts_decorate([
    ClientCollection.annotate({
        path: "/rcb-tcf-vendor-conf",
        singlePath: "/rcb-tcf-vendor-conf/:id",
        namespace: "wp/v2",
        methods: [
            RouteHttpVerb.GET
        ],
        request
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof TcfStore === "undefined" ? Object : TcfStore
    ])
], TcfVendorConfigurationCollection);
export { TcfVendorConfigurationCollection };
